// extracted by mini-css-extract-plugin
export default {"container":"video_container__hXd3E","loading":"video_loading__Gv3hc"};